module.exports = __webpack_public_path__ + "img/mandiri.1777bf9a.png";